import feedbackController from './feedbackController'

export default feedbackController



// WEBPACK FOOTER //
// ../src/controllers/feedbackController/index.js